import './fanzine.css'

const resolveAssetPath = (assetPath) => {
  const resolvedAsset = require(`../../${assetPath}`);
  return resolvedAsset?.default || resolvedAsset;
};

export default function Fanzine({ href, imgUrl }) {
  const imageSrc = resolveAssetPath(imgUrl);

  return (
    <div 
      className="press__fanzines-container__fanzine">
      <a 
        className="press__fanzines-container__fanzine-link"
        href={href}
        target='_blank' 
        rel='noreferrer'
      >
        <img 
          className="press__fanzines-container__fanzine-image" 
          src={imageSrc}
          alt='Cover from the fanzine number' 
        />
      </a>
    </div>
  )
}
